module.exports = __webpack_public_path__ + "static/img/peopl.6b1e252e.png";